import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiMethod } from '../apimethods/api-method';
import * as ngswal from "sweetalert";
import { customfunctions, DataParam } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { MailTemplateAPIModel } from './mailTemplate-model';
declare var $;

@Component({
  selector: 'app-mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.css']
})
/** MailTemplate component*/
export class MailTemplateComponent implements OnInit {
  modelItem = new MailTemplateAPIModel();
  @ViewChild('dataTable', { static: false }) table;

  dataTable: any;
  dataSet: any;
  title: string;
  moduleName: string;
  template: string;
  mailContent: string;
  showModal: boolean = false;
  popUpButtonText: string;
  StageStatus: any;
  Publishers: any;
  Journals: any;
  showpopupModal: boolean;
  RemPopUpButtonText: string;
  RemTitle: string;
  LanguageList: any;
  CountryList: any;

  ngOnInit() {

    ApiMethod.getBaseUrl();
    $('#Txt_MailBody').jqte();
    $('#Txt_SIMailBody').jqte();
    $('#Txt_RemMailBody').jqte();
    $('#popupbody').css('height', (GlobalConstants.size.height - 15));
    $('#Divmail .jqte_editor').css({ 'height': (GlobalConstants.size.height - 300), 'resize': 'none' });
    $('#DivRemMail .jqte_editor').css({ 'height': (GlobalConstants.size.height - 300), 'resize': 'none' });
    $('#SI_Divmail .jqte_editor').css({ 'height': (GlobalConstants.size.height - 300), 'resize': 'none' });
  }

  /** MailTemplate ctor */
  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <MailTemplateAPIModel>data["MailTemplateAPIPage"];
        localStorage.aRowId = "";

        $('#ddlStageStatus').select2({
          placeholder: "Select Stage Status",
          allowClear: true, tags: false,
          dropdownParent: "#mailtemplateModal"
        });
        $('#ddlStageStatus').val([]).trigger('change');

        //publisher list
        $('#ddlPublishers').select2({
          placeholder: "Select Publisher",
          allowClear: true, tags: false,
          dropdownParent: "#mailtemplateModal"
        });
        $('#ddlPublishers').val([]).trigger('change');

        //publisher
        $('#ddlPublisher').select2({
          placeholder: "Select Publisher",
          allowClear: true, tags: false,
          dropdownParent: "#mailtemplateModal"
        });
        $('#ddlPublisher').val([]).trigger('change');

        $('#ddlJournals').select2({
          placeholder: "Select Journals",
          allowClear: true, tags: false,
          dropdownParent: "#mailtemplateModal"
        });
        $('#ddlJournals').val([]).trigger('change');

        $('#ddl_IntervalType').select2({
          placeholder: "Select Interval Type",
          allowClear: true, tags: false,
          dropdownParent: "#MailTempRem"
        });
        $('#ddl_IntervalType').val([]).trigger('change');

        this.LoadGeneralData();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  LoadGeneralData() {
    this.getMailTemplates();
    this.GetStageStatusList();
    this.GetPublishersList();
    this.GetJournalsList();
    this.GetCountryLanguageList();
  }

  ngAfterViewChecked(): void {
    if ($('.jqte').length == 0) {
      $('#Txt_MailBody').jqte();
      $('#Txt_SIMailBody').jqte();
    }

    let filterLoadType = $('#ULTabul .active').attr('name');
    if (filterLoadType == 'TemplateDetails') {
      $('#tab_btn').hide();
    } else {
      $('#tab_btn').show();
    }
  }
  //Get All StageStatus list
  GetStageStatusList(): void {
    ApiMethod.getMethod(this.modelItem.StageStatusAPI).subscribe(
      result => {
        this.StageStatus = result.aStatusList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All StageStatus list
  GetPublishersList(): void {
    ApiMethod.getMethod(this.modelItem.PublishersAPI).subscribe(
      result => {
        this.Publishers = result.aPublishersList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All StageStatus list
  GetJournalsList(): void {
    ApiMethod.getMethod(this.modelItem.JournalsAPI + '/' + localStorage.aPubID).subscribe(
      result => {
        this.Journals = result.aJournalsList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //Get All Country and Language list
  GetCountryLanguageList(): void {
    ApiMethod.getMethod(this.modelItem.CountryLanguageListApi).subscribe(
      result => {
        this.LanguageList = result.Language;
        this.CountryList = result.Country;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }


  //Get mainGrid MailTemplates details
  getMailTemplates() {
    $("#LoadingImage").show();
    var mailData = {
      PublisherID: localStorage.aPubID,
      UpdatedBy: localStorage.aLoginID
    };
    ApiMethod.postMethod(this.modelItem.GetMailTemplateListAPI, mailData).subscribe(
      result => {
        this.dataSet = JSON.stringify(result.aitemList);
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let acolList = result.acolListL;
        let dataItem = new DataParam();
        dataItem.acolList = acolList;
        dataItem.aNewButtonName = "btn_AddNew";
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = "MailTemplateModule";
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      }
    );
  }

  //show mailTemplate Details by ID
  show() {
    $("#LoadingImageReopen").show();
    this.clear();

    if (localStorage.aEID != 0) {

      ApiMethod.getMethod(this.modelItem.GetMailTemplateDetailsAPI + "/" + localStorage.aEID).subscribe(
        response => {
          this.showModal = true;
          var aitems = response.atemaplateDetails;
          var aitemRem = response.aMailtempRemlist;
          console.log(aitems);
          $('#Txt_ModuleName').val(aitems.ModuleName);
          $('#Txt_Template').val(aitems.Template);
          $('#Txt_MailContent').val(aitems.MailContent);
          $('#Txt_DisplayFromEmailid').val(aitems.DisplayFromEmailId);
          $('#Txt_FromEmailid').val(aitems.FromEmailId);
          $('#Txt_NotifyToEmail').val(aitems.NotifyToEmail);
          $('#Txt_NotifyCCEmail').val(aitems.NotifyCcEmail);
          $('#Txt_NotifyBCCEmail').val(aitems.NotifyBccEmail);
          $('#Txt_MailSubject').val(aitems.MailSubject);
          $('#Txt_MailDisclaimer').val(aitems.MailDisclaimer);
          $('#Txt_SIMailSubject').val(aitems.SI_MailSubject);
          $('#SI_Divmail .jqte_editor').html(aitems.SI_MailBody);//Jqte editor
          $('#Divmail .jqte_editor').html(aitems.MailBody);//Jqte editor
          $('#ddlCountry').val(aitems.CountryId);
          $('#ddlLanguage').val(aitems.LanguageId);

          $("#ddlStageStatus").val(aitems.StageStatusId).change();

          //Journals
          if (aitems.JournalList != null) {
            var data = aitems.JournalList.split(',');
          } else
            data = null;
          var selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlJournals').val(selectedValues).change();

          //Publishers
          if (aitems.PublisherList != null) {
            var data = aitems.PublisherList.split(',');
          } else
            data = null;
          var selectedValues = new Array();
          try {
            for (var i = 0; i < data.length; i++) {
              selectedValues[i] = data[i];
            }
          } catch (e) {
          }
          $('#ddlPublishers').val(selectedValues).change();

          //Xml Path Details Table 
          $("#tblMailtempRem tbody").html("");
          if (aitemRem.length != 0) {
            var nRowR = "";
            for (var i = 0; i < aitemRem.length; i++) {
              nRowR += "<tr id='trRc_" + (i + 1).toString() + "'>";
              nRowR += "<td for='RowId'>" + (i + 1).toString() + "</td>";
              nRowR += "<td for='RemId' style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].Id) + "</td>";
              nRowR += "<td for='MailTemplateId' style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].MailTemplateId) + "</td>";
              nRowR += "<td for='ReminderCount'>" + GlobalConstants.isNullCheck(aitemRem[i].ReminderCount) + "</td>";
              nRowR += "<td for='Sequence' style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].Sequence) + "</td>";
              nRowR += "<td for='IntervalType' >" + GlobalConstants.isNullCheck(aitemRem[i].IntervalType) + "</td>";
              nRowR += "<td for='IntervalDay'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].IntervalDay) + "</td>";
              nRowR += "<td for='Subject' >" + GlobalConstants.isNullCheck(aitemRem[i].Subject) + "</td>";
              nRowR += "<td for='FromEmail'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].FromEmail) + "</td>";
              nRowR += "<td for='ToEmail'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].ToEmail) + "</td>";
              nRowR += "<td for='CCEmail'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].CCEmail) + "</td>";
              nRowR += "<td for='BCCEmail'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].BCCEmail) + "</td>";
              nRowR += "<td for='Signature'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].Signature) + "</td>";
              nRowR += "<td for='MailBody'  style='display:none;'>" + GlobalConstants.isNullCheck(aitemRem[i].MailBody) + "</td>";
              nRowR += "<td for='Action'  style='text-align: center;width:10%'>"
                + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;'  onclick=localStorage.aRowId='" + (i + 1).toString() + "';$('#btnAddUpdate').trigger('click');></i>&nbsp;"
                + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.aRowId='" + (i + 1).toString() + "';$('#btnDelete').trigger('click');></i>"
                + "</td>";
              nRowR += "</tr>";
            }
            $("#tblMailtempRem tbody").append(nRowR);
          }



          this.title = "Mail Template :" + aitems.ModuleName + "";
          this.popUpButtonText = "Update";

          $("#LoadingImageReopen").hide();
        }, error => {
          $("#LoadingImageReopen").hide();
          ngswal("Failed !", error.message, "error");
        });

    } else {
      //shoe popup
      this.showModal = true;
      //Title and button Values
      this.popUpButtonText = "Add";
      this.title = "Mail Temaplate Details";
      localStorage.aEID = "";
      $("#LoadingImageReopen").hide();
    }
  }

  //hide popup
  hide() {
    this.showModal = false;
    localStorage.aEID = "";
    $('#ULTabul a[href="#divTempDetails"]').trigger('click');
  }

  //EmailID validation
  emailIdOnly(event): boolean {
    const emailValue = event.currentTarget.value.trim(); // Trim the email value
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    if (!filter.test(emailValue)) {
      event.currentTarget.value = "";
      return ngswal("Warning!", "Email not valid. Please try again.", "warning");
    }
    return true;
  }

  //Multiple Email Id validation
  EmailValidation(event) {
    let Worngmailcount = 0;
    let str = event.currentTarget.value;
    let arr = str.split(/[;,]/);
    const regex = /^\{.*\}$/;
    var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
    let validEmails = [];
    for (let i = 0; i < arr.length; i++) {
      let email = arr[i].trim();
      const isMatch = regex.test(email);
      if (isMatch) {
        validEmails.push(email);
        continue;
      } else {
        if (!filter.test(email)) {
          Worngmailcount++;
          continue;
        } else {
          validEmails.push(email);
        }
      }
    }
    event.currentTarget.value = validEmails.join(";");
    if (Worngmailcount > 0) {
      ngswal("Warning !", "Please Check Email ID!", "warning");
    }
  }


  //Clear form values
  clear() {
    //txt values
    $('#Txt_ModuleName').val('');
    $('#Txt_Template').val('');
    $('#Txt_MailContent').val('');
    $('#Txt_DisplayFromEmailid').val('');
    $('#Txt_FromEmailid').val('');
    $('#Txt_NotifyToEmail').val('');
    $('#Txt_NotifyCCEmail').val('');
    $('#Txt_NotifyBCCEmail').val('');
    $('#Txt_MailSubject').val('');
    $('#Txt_SIMailSubject').val('');
    $('#Txt_MailDisclaimer').val('');
    $('#Txt_MailBody').val('');
    //Jqte editor
    $('#Divmail .jqte_editor').html('');
    $('#SI_Divmail .jqte_editor').html('');
    //dll values
    $('#ddlStageStatus').val(0).change();
    $('#ddlPublishers').val(0).change();
    $('#ddlJournals').val(0).change();
    $('#ddlCountry').val(0).change();
    $('#ddlLanguage').val(0).change();
    $("#tblMailtempRem tbody").html("");
  }

  //update mailtemplate details
  UpdateTemplate(): void {
    if ($('#Txt_ModuleName').val() == "") {
      ngswal("Failed !", "Enter Moduel Name..!", "warning");
    } else if ($('#Txt_Template').val() == "") {
      ngswal("Failed !", "Enter Template", "warning");
    } else if ($('#Txt_MailContent').val() == "") {
      ngswal("Failed !", "Enter Mail Content..!", "warning");
    } else if ($('#Txt_FromEmailid').val() == "") {
      ngswal("Failed !", "Enter From Email id!", "warning");
    } else if ($('#Txt_NotifyToEmail').val() == "") {
      ngswal("Failed !", "Enter Notify To Email!", "warning");
    } else if ($('#Txt_MailSubject').val() == "") {
      ngswal("Failed !", "Enter Mail Subject!", "warning");
    } else if ($('#Txt_MailBody').val() == "") {
      ngswal("Failed !", "Enter Mail Body!", "warning");
    }
    else {
      $("#LoadingImageReopen").show();
      var aFieldList = [];
      aFieldList = GlobalConstants.GetTableRowToList('tblMailtempRem', null, true);
      for (var i = 0; i < aFieldList.length; i++) {
        aFieldList[i] = aFieldList[i].toString();
      }
      var MailTemplatedetails = {
        ID: localStorage.aEID,
        PublisherID: localStorage.aPubID,
        PublisherList: localStorage.aPubID,
        ModuleName: $("#Txt_ModuleName").val(),
        Template: $("#Txt_Template").val(),
        MailContent: $("#Txt_MailContent").val(),
        MailSubject: $("#Txt_MailSubject").val(),
        MailBody: $("#Txt_MailBody").val(),
        SI_MailSubject: $("#Txt_SIMailSubject").val(),
        SI_MailBody: $("#Txt_SIMailBody").val(),
        DisplayFromEmailId: $("#Txt_DisplayFromEmailid").val(),
        FromEmailId: $("#Txt_FromEmailid").val(),
        NotifyToEmail: $("#Txt_NotifyToEmail").val(),
        NotifyCcEmail: $("#Txt_NotifyCCEmail").val(),
        NotifyBccEmail: $("#Txt_NotifyBCCEmail").val(),
        MailDisclaimer: $("#Txt_MailDisclaimer").val(),
        StageStatusId: $('#ddlStageStatus').val(),
        CountryId: $('#ddlCountry').val(),
        LanguageId: $('#ddlLanguage').val(),
        JournalList: $('#ddlJournals').val().toString().split(',').filter(num => !isNaN(Number(num))).join(','),
        FieldList: aFieldList,
        CreatedBy: localStorage.aLoginID,
        UpdatedBy: localStorage.aLoginID,
      };
      console.log(MailTemplatedetails);
      ApiMethod.postMethod(this.modelItem.UpdateMailtempAPI, MailTemplatedetails).subscribe(
        Response => {

          this.getMailTemplates();
          this.showModal = false;
          if (Response.status) {
            ngswal("Success !", Response.message, "success");
          } else {
            ngswal("Success !", Response.message, "Failed");
          }

          $("#LoadingImageReopen").hide();
        }, error => {
          ngswal("Failed!", error.Message, "error");
          $("#LoadingImageReopen").hide();
        }
      );
    }
  }

  //< --------------------------Mail Template Remainder--------------------------------->

  /* Show Remainder popup */
  showRemdetails() {
    $("#LoadingImagePopup1").show();
    this.showpopupModal = true;
    this.clearRemData();
    if (localStorage.aRowId != 0) {
      let trId = '#trRc_' + localStorage.aRowId;
      $("#Txt_RemainderCount").val($(trId).find('td')[3].outerText);
      $("#Txt_Sequence").val($(trId).find('td')[4].outerText);
      $("#ddl_IntervalType").val($(trId).find('td')[5].innerHTML).change();//ddl
      $("#Txt_IntervalDay").val($(trId).find('td')[6].outerText);
      $("#Txt_Subject").val($(trId).find('td')[7].outerText);
      $("#Txt_FromEmail").val($(trId).find('td')[8].outerText);
      $("#Txt_ToEmail").val($(trId).find('td')[9].innerHTML);
      $("#Txt_CCEmail").val($(trId).find('td')[10].outerText);
      $("#Txt_BCCEmail").val($(trId).find('td')[11].outerText);
      $("#Txt_Signature").val($(trId).find('td')[12].innerHTML);
      $('#DivRemMail .jqte_editor').html($(trId).find('td')[13].innerHTML);
      this.RemTitle = "Update Remainder " + this.title;
      this.RemPopUpButtonText = "Update"
      $("#LoadingImagePopup1").hide();
    } else {
      this.RemTitle = "Add Remainder";
      this.RemPopUpButtonText = "Add";
      $("#LoadingImagePopup1").hide();
    }

  }

  /* claer Remainder popup Field values*/
  clearRemData() {
    $("#Txt_RemainderCount").val("");
    $("#Txt_Sequence").val("");
    $("#Txt_IntervalDay").val("");
    $("#Txt_FromEmail").val("");
    $("#Txt_ToEmail").val("");
    $("#Txt_CCEmail").val("");
    $("#Txt_BCCEmail").val("");
    $("#Txt_Signature").val("");
    $("#Txt_Subject").val("");
    $('#DivRemMail .jqte_editor').html("");
    $("#ddl_IntervalType").val(0).change();//ddl
  }

  /* Hide Remainder popup */
  hideRemPopup() {
    this.showpopupModal = false;
    localStorage.aRowId = "";

  }

  /*Add Update Remainder*/
  addUpdateRemainder() {

    if ($('#Txt_RemainderCount').val() == '') {
      ngswal("Warning !", "Enter Remainder Count!", "warning");
    }
    else if ($('#Txt_Sequence').val() == '') {
      ngswal("Warning !", "Enter Sequence!", "warning");
    }
    else if ($('#ddl_IntervalType').val() == null) {
      ngswal("Warning !", "Enter Interval Type!", "warning");
    }
    else if ($('#Txt_IntervalDay').val() == '') {
      ngswal("Warning !", "Enter Interval Day!", "warning");
    }
    //else if ($('#Txt_FromEmail').val() == '') {
    //  ngswal("Warning !", "Enter FromEmail !", "warning");
    //}
    else if ($('#Txt_ToEmail').val() == '') {
      ngswal("Warning !", "Enter ToEmail !", "warning");
    }
    //else if ($('#Txt_CCEmail').val() == '') {
    //  ngswal("Warning !", "Enter CC Email !", "warning");
    //}
    //else if ($('#Txt_BCCEmail').val() == '') {
    //  ngswal("Warning !", "Enter BCC Email !", "warning");
    //}
    //else if ($('#Txt_Signature').val() == '') {
    //  ngswal("Warning !", "Enter Signature !", "warning");
    //}
    else if ($('#Txt_Subject').val() == '') {
      ngswal("Warning !", "Enter Subject !", "warning");
    }
    else if ($('#Txt_RemMailBody').val() == '') {
      ngswal("Warning !", "Enter Remainder Mail Body !", "warning");
    } else {
      $("#LoadingImagePopup1").show();
      if (localStorage.aRowId == "") {
        var zRowLength = $("#tblMailtempRem").find("tr").length;
        var MailtempRemID = localStorage.aEID;
        $("#tblMailtempRem tbody").append(
          "<tr id='trRc_" + zRowLength.toString() + "'>" +
          "<td>" + zRowLength.toString() + "</td>" +
          "<td style='display:none;'></td>" +
          "<td style='display:none;'>" + MailtempRemID + "</td>" +
          "<td>" + $("#Txt_RemainderCount").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_Sequence").val() + "</td>" +
          "<td>" + $("#ddl_IntervalType option:selected").text() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_IntervalDay").val() + "</td>" +
          "<td>" + $("#Txt_Subject").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_FromEmail").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_ToEmail").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_CCEmail").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_BCCEmail").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_Signature").val() + "</td>" +
          "<td style='display:none;'>" + $("#Txt_RemMailBody").val() + "</td>" +
          "<td style='text-align: center'>"
          + "<i class='bx bxs-edit-alt' style='color: #34c38f; font-size: 20px;cursor:Pointer;' onclick=localStorage.aRowId='" + zRowLength.toString() + "';$('#btnAddUpdate').trigger('click');></i>&nbsp;"
          + "<i class='bx bxs-trash' style='color: #f46a6a; font-size: 20px;cursor:Pointer;' onclick=localStorage.aRowId='" + zRowLength.toString() + "';$('#btnDelete').trigger('click');></i></td>" +
          "</tr>"
        );
        this.clearRemData();
        this.hideRemPopup();
        $("#LoadingImagePopup1").hide();
      } else {
        let trId = "#trRc_" + localStorage.aRowId;
        $(trId).find("td")[3].outerHTML = "<td>" + $("#Txt_RemainderCount").val() + "</td>";
        $(trId).find("td")[4].outerHTML = "<td style='display:none;'>" + $("#Txt_Sequence").val() + "</td>";
        $(trId).find('td')[5].outerHTML = "<td>" + $('#ddl_IntervalType option:selected').text() + "</td>";
        $(trId).find("td")[6].outerHTML = "<td style='display:none;'>" + $("#Txt_IntervalDay").val() + "</td>";
        $(trId).find("td")[7].outerHTML = "<td>" + $("#Txt_Subject").val() + "</td>";
        $(trId).find("td")[8].outerHTML = "<td style='display:none;'>" + $("#Txt_FromEmail").val() + "</td>";
        $(trId).find("td")[9].outerHTML = "<td style='display:none;'>" + $("#Txt_ToEmail").val() + "</td>";
        $(trId).find("td")[10].outerHTML = "<td style='display:none;'>" + $("#Txt_CCEmail").val() + "</td>";
        $(trId).find("td")[11].outerHTML = "<td style='display:none;'>" + $("#Txt_BCCEmail").val() + "</td>";
        $(trId).find("td")[12].outerHTML = "<td style='display:none;'>" + $("#Txt_Signature").val() + "</td>";
        $(trId).find("td")[13].outerHTML = "<td style='display:none;'>" + $("#Txt_RemMailBody").val() + "</td>";
        this.clearRemData();
        this.hideRemPopup();
        $("#LoadingImagePopup1").hide();
      }
    }
  }

  //Delete html table row
  DeleteRow() {
    var rowCount = $('#tblMailtempRem tbody tr').length;
    if (rowCount <= 1) {
      ngswal("Warning !", "Maintain Atleast one Remainder record !", "warning");
      return false;
    }
    ngswal({
      title: "Are you confirm to delete Remainder Details?",
      text: "You will not be able to recover this data!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $("#trRc_" + localStorage.aRowId).closest("tr").remove();
          $("table#tblMailtempRem tbody").each(function () {
            $(this).children().each(function (index) {
              $(this).find('td').first().html((index + 1).toString());
            });
          });
          ngswal("Deleted!", "Your data has been deleted.", "success");
        } else {
          ngswal("Cancelled", "Your data is safe :)", "warning");
          return false;
        }
      });


  }
}

